import React, { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import styles from "./HomeNew.module.css";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/Latest Logo.png";
import Footer from "./HomeFooter";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { GoLightBulb } from "react-icons/go";
import { RxHamburgerMenu } from "react-icons/rx";
import Fade from "react-reveal/Fade";
import { customTextColor } from "../../utils/const";

const Refund = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  return (
    <Box>
      <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>
        <span className={styles.nav_links}>
          <a onClick={() => navigate("/")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Home
            </b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "5px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Our Platform
            </b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              About us
            </b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Contact us
            </b>
          </a>
          <Box className={styles.login_btn}>
            <a onClick={() => navigate("/login")}>
              <b>Login</b>
            </a>
          </Box>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("/")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Home
              </Typography>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "20px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </Typography>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                About us
              </Typography>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Contact us
              </Typography>
            </a>
            <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                <b>Login</b>
              </a>
            </Box>
          </Box>
        )}
      </Box>
      <Box sx={{ padding: "35px" }} id="home" />
      <Box className={styles.home_structure}>
        <Fade bottom delay={200}>
          <Box className={styles.configuration_structure}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={4}
                md={3}
                sx={{ backgroundColor: "#fff", border: "2px solid #f2f2f2" }}
              >
                <Box className={styles.security_body}>
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      color: customTextColor,
                      fontSize: "17px !important",
                      margin: "4px 0",
                    }}
                    onClick={() => navigate("/privacy-policy")}
                  >
                    <b>Privacy Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/refund-policy")}
                >
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b style={{ borderBottom: "2px solid #1991e0" }}>
                      Refund Policy
                    </b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/term-of-use")}
                >
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Website Terms of Use</b>
                  </Box>
                </Box>

                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/data-backup-policy")}
                >
                  <Box
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Data Backup Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/safe-job-search")}
                >
                  <Box
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Safe Job Search & Applies Security </b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  onClick={() => navigate("/reporting-fraud")}
                  style={{ margin: "14px 0" }}
                >
                  <Box
                    aria-controls="panel3-content"
                    id="panel3-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Reporting fraud</b>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
                md={9}
                style={{
                  paddingLeft: window.innerWidth < 600 ? "15px" : "0",
                }}
              >
                <Box
                  className={styles.employer_details}
                  sx={{ lineHeight: "2" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      padding: "10px 30px 120px 20px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{ fontSize: "20px !important", userSelect: "none" }}
                      >
                        <b>Refund policy</b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        At Povital we want you to be happy. So, if you are not
                        completely satisfied with our services, we offer a
                        30-day refund guarantee.
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        You can get the full refund within 30 days from the
                        purchase date, if and when, you didn’t get to use the
                        service, that is, you haven't view resume, downloaded
                        any resource from <a href=""> povital.com.</a>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        If that is your case, you can request the refund{" "}
                        <a href="">
                          <b>help desk</b>
                        </a>{" "}
                        writing subscription/Refund/Current invoice) from the
                        registered email address linked to your subscription
                        account.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        You can only request the refund of the current billing
                        period. Please note that previous subscriptions cannot
                        be refunded.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        It is important that you send the refund request from
                        the registered email address linked to your Povital
                        account in order to authorize it. If possible, please
                        include the payment ID so we can complete the process as
                        quickly as possible.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <b>
                          If you have issues to remember the email address
                          linked to your Povital account,
                        </b>{" "}
                        please provide us with the following details in order to
                        find your payment:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            Last 4 digits of the card used for the payment
                          </li>
                          <li>Expiry date on the card</li>
                          <li>Exact date of the payment</li>
                          <li>Transaction ID</li>
                        </ul>
                      </Typography>
                    </Box>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Box>
      <Footer />
    </Box>
  );
};

export default Refund;
